// extracted by mini-css-extract-plugin
export default {"UserItem":"UserItem_UserItem__xUkkw","status":"UserItem_status__zDE91","online":"UserItem_online__66OaN","name":"UserItem_name__NijQh","post":"UserItem_post__f9+Ff"};